import React from "react";
import {Divider, List, NavBar, Dialog, Toast} from "antd-mobile";
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import {useNavigate} from "react-router-dom";
import {UserMenuPath} from "../../../enums/DeliveryNavigatePathEnum";
import {t} from "../../../i18n";
import {GlobalOutline, DeleteOutline} from "antd-mobile-icons";
import {ReactComponent as NavigationAppSvg} from "../icons/svgs/navigationApp.svg";
import {ReactComponent as RouteEndpointsSvg} from "./icons/svgs/routeEndpoints.svg";
import {deactivateAccount, getUserInfo, isDspManager} from "../../../utils/auth";

interface SettingsProps {
}


const SettingsPage: React.FC<SettingsProps> = () => {
    const navigate = useNavigate();
    const userInfo = getUserInfo();
    const shouldShowDeactivateAccount = userInfo?.account?.id === '216';
    const shouldShowRouteEndpointsSetting = !isDspManager();

    const handleDeactivateAccount = async () => {
        const result = await Dialog.confirm({
            title: t('pages.useMenu.deactivateAccountTitle'),
            content: t('pages.useMenu.deactivateAccountDesc'),
            confirmText: t('pages.useMenu.deactivateAccountConfirmText'),
            cancelText: t('pages.useMenu.deactivateAccountCancelText'),
        });

        if (result) {
            try {
                const success = await deactivateAccount('/login');
                if (success) {
                    Toast.show({
                        icon: 'success',
                        content: t('pages.useMenu.deactivateAccountSuccess'),
                    });
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: t('pages.useMenu.deactivateAccountError'),
                    });
                }
            } catch (error) {
                Toast.show({
                    icon: 'fail',
                    content: t('pages.useMenu.deactivateAccountError'),
                });
            }
        }
    };

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                onBack={() => navigate(-1)}
            >
                {t('pages.useMenu.settings')}
                </NavBar>
            </div>
            <Divider/>
            <List
                className="flex-grow"
                style={{
                    '--border-bottom': 'none',
                    '--border-top': 'none',
                }}>
                <List.Item prefix={<GlobalOutline />} onClick={() => { navigate(UserMenuPath.USER_MENU_SETTINGS_LANGUAGE) }}>
                    {t('pages.useMenu.language')}
                </List.Item>
                <List.Item prefix={<NavigationAppSvg width={19} height={19} />} onClick={() => { navigate(UserMenuPath.USER_MENU_SETTINGS_NAVIGATION_APP) }}>
                    {t('pages.useMenu.navigationApp')}
                </List.Item>
                {shouldShowRouteEndpointsSetting && (
                    <List.Item
                        prefix={<RouteEndpointsSvg width={19} height={19} className="text-zinc-800" />}
                        onClick={() => { navigate(UserMenuPath.USER_MENU_SETTINGS_ROUTE_ENDPOINTS_NATIVE) }}
                    >
                        {t("pages.useMenu.routeEndpointsSetting")}
                    </List.Item>
                )}
                {shouldShowDeactivateAccount && (
                    <List.Item 
                        prefix={<DeleteOutline />} 
                        onClick={handleDeactivateAccount}
                    >
                        {t('pages.useMenu.deactivateAccount')}
                    </List.Item>
                )}
            </List>

        </div>
    );
};

export default SettingsPage;